import { consoleSandbox } from '@sentry/utils';

function warn() {
  consoleSandbox(() => {
    // eslint-disable-next-line no-console
    console.warn('You are using metrics even though this bundle does not include tracing.');
  });
}

const metricsShim = {
  increment: warn,
  distribution: warn,
  set: warn,
  gauge: warn,
  timing: (_name, value) => {
    warn();
    if (typeof value === 'function') {
      return value();
    }
  },
};

export { metricsShim };
//# sourceMappingURL=metrics.js.map
